import modal from './modal';

export default modal;



// WEBPACK FOOTER //
// ./src/components/modal/index.js